<template>
  <div>
    <v-simple-table class="ma-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">{{ $t("settings.multiuser.role") }}</th>
            <th class="text-right"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in multiusers" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.role }}</td>
            <td>
              <v-btn
                color="primary"
                outlined
                small
                @click.stop="removeMultiuser(item.id)"
              >
                {{ $t("settings.multiuser.removeAccess") }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    multiusers: [],
  }),
  mounted() {
    let userData = null;
    try {
      userData = JSON.parse(localStorage.getItem("userData"));
    } catch (e) {
      userData = null;
    }
    const ids = userData?.client?.multiusers || [];
    ids.forEach((element) => {
      this.$store.dispatch("getSingleUser", element).then((item) => {
        if (item) this.multiusers.push(item);
      });
    });
  },
  methods: {
    removeMultiuser(id) {
      this.$store.dispatch("multiuserRevoke", { multiuser: id }).then(() => {
        this.$store.dispatch("getUserInfo");
        //reload page
        location.reload();
      });
    },
  },
};
</script>
